import moment, {Moment} from 'moment-timezone'
import {useCallback} from 'react'

import {useUpmPlantTimezone} from './useUpmPlantTimezone'

/**
 * Hook that returns a function to get the current moment in the plant's timezone.
 *
 * @param plantId - The plant ID to get the current time for
 * @returns A callback function that returns the current moment in the plant's timezone
 *
 * @example
 * ```typescript
 * const getPlantNow = useUpmPlantNow('0014')
 * const currentTime = getPlantNow() // Returns current moment in plant's timezone
 * ```
 */
export const useUpmPlantNow = (plantId: string): (() => Moment) => {
  const timezone = useUpmPlantTimezone(plantId)
  return useCallback(() => moment().tz(timezone), [timezone])
}
